import { render, staticRenderFns } from "./switchlang.vue?vue&type=template&id=64e2bb5e"
import script from "./switchlang.vue?vue&type=script&lang=js"
export * from "./switchlang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports